import { snakeCase } from "lodash";
import { analytics } from './analytics';
import mutationObserver from 'utils/mutation_observer';

const SELECTOR = '[data-click-tracker]';
const BASE_DATA_ATTR = 'clickTracker';
const ARGS_DATA_ATTR = 'Arg';

/**
 * Handle clicks on certain buttons / links.
 *
 * Parses the dataset attributes on an element, and sends an `analytics.track` event.
 *
 * By default, the eventName is the value of [data-click-tracker].
 *
 * @param event
 * */
function handleClick(event) {
  const { currentTarget: button } = event;

  const eventName = button.dataset[BASE_DATA_ATTR];
  const properties = {};

  for (let attr in button.dataset) {
    if (attr.startsWith(BASE_DATA_ATTR) && attr.indexOf(ARGS_DATA_ATTR) !== -1) {
      const argAttr = attr.substring(BASE_DATA_ATTR.length);
      let [, argKey] = argAttr.split(ARGS_DATA_ATTR);
      argKey = snakeCase(argKey);
      properties[argKey] = button.dataset[attr];
    }
  }

  if (typeof (eventName) === 'undefined') {
    console.error(
      `[data-click-tracker] Encountered error tracking click for ${button}. 
                    No event name found. Pass an explicit event name using [data-click-tracker].`
    );
  } else {
    analytics.track(eventName, properties);
  }
}

// Create our listeners for all elements that have the click tracker data attribute.
window.addEventListener('DOMContentLoaded', () => {
  for (let el of document.querySelectorAll(SELECTOR))
    el.addEventListener('click', handleClick);
  mutationObserver(SELECTOR, (element) => {
    element.addEventListener('click', handleClick);
  })
});
